import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPaginationPartrequests } from "../../reduxStore/entities/partrequests";
//custom hooks
import useNotificationMessages from "../../hooks/useNotificationMessages";
// components
import CustomDataGrid from "../../components/CustomDataGrid/CustomDataGrid2";
//core
import Layout from "../../core/Layout";
import resources from "../../core/Localization/Localization.js";
//common
import { partrequestColumns } from "../../common/DataGridColumns/Requests";
import { handleTableLoad } from "../../common/RequestTableData";
//utils
import { notificationTypes } from "../../variables/notificationTypes";
import { areNotificationsEnabled } from "../../utils/areNotificationsEnabled.js";

export default function Requests() {
    const notifications = useNotificationMessages();

    // Store hooks
    const partrequests = useSelector((state) => state.partrequests.partrequests);
    const count = useSelector((state) => state.partrequests.count);
    const dataLoaded = useSelector((state) => state.partrequests.dataLoaded);
    const dispatch = useDispatch();

    // State hooks
    const [rows, setRows] = React.useState(handleTableLoad(partrequests));
    const [totalRows, setTotalRows] = React.useState(count);
    const [currentFilters, setCurrentFilters] = React.useState(null);

    const columns = React.useMemo(partrequestColumns, [resources]);

    // React hooks

    const notificationsEnabled = areNotificationsEnabled();

    useEffect(() => {
        if (notificationsEnabled) {

            notifications.publish({
                title: "Part request read",
                body: "Part request read",
                payload: {
                    id: "null",
                    topic: notificationTypes.partRequestsRead,
                },
            });
        }
    }, []);

    useEffect(() => setTotalRows(count), [count]);
    useEffect(() => setRows(handleTableLoad(partrequests)), [partrequests, dataLoaded]);

    useEffect(() => {
        if (notificationsEnabled) {

            const partCreatedListener = notifications.subscribe(notificationTypes.partRequestCreated, handler);
            const partUpdatedLisetner = notifications.subscribe(notificationTypes.partRequestStateUpdate, handler);
            const offerCreatedLisetner = notifications.subscribe(notificationTypes.partOfferCreated, handler);

            return () => {
                partCreatedListener.unsubscribe();
                partUpdatedLisetner.unsubscribe();
                offerCreatedLisetner.unsubscribe();
            };
        }
    }, [currentFilters]);

    const handler = (message) => {
        currentFilters ? doSearchPartrequests(currentFilters) : doSearchPartrequests();
    };

    // Event handlers
    const onFiltersChanged = (filters) => doSearchPartrequests(filters);

    const onPageChange = (filters) => {
        doSearchPartrequests(filters);
        setRows(handleTableLoad(partrequests));
    };

    const onRowClick = (id) => {
        if (id) {
            window.open("/admin/requests/" + id, "_blank");
        }
    };

    // Private (helper) functions
    const doSearchPartrequests = (filters) => {
        setCurrentFilters({ ...filters });
        dispatch(getPaginationPartrequests(filters));
    };

    return (
        <Layout>
            <CustomDataGrid
                title={resources.partRequests.title}
                rows={rows}
                columns={columns}
                totalRows={totalRows}
                loading={!dataLoaded}
                handleRowClick={onRowClick}
                handleFilterChange={onFiltersChanged}
                handlePageChange={onPageChange}
                handleDataInit={doSearchPartrequests}
                ignoreUrl={false}
            />
        </Layout>
    );
}
